import { ApiResponse, fetcher } from './base-api';
import {
  ArticleEntity,
  ArticleListResponse,
  GetArticleListParams,
} from './types/article.type';

export const getPrivacyArticleList = async (): Promise<
  ApiResponse<ArticleEntity[]>
> => {
  return fetcher<ArticleEntity[]>('/article/privacy');
};

export const getArticleList = async (
  params?: GetArticleListParams,
): Promise<ApiResponse<ArticleListResponse>> => {
  return fetcher<ArticleListResponse>('/article', { params });
};

export const getArticleDetail = async (
  id: number,
): Promise<ApiResponse<ArticleEntity>> => {
  return fetcher<ArticleEntity>(`/article/${id}`);
};

export const getMainTopArticleList = async (): Promise<
  ApiResponse<ArticleEntity[]>
> => {
  return fetcher<ArticleEntity[]>('/article/main-top');
};
